export default __webpack_public_path__ + "static/media/background.554ecf8c.svg";